<template>
  <div
    class="block-placeholder d-flex align-items-center justify-content-center flex-column"
  >
    <v-icon :icon="icon" size="2.5rem" class="text-muted" />
    <span class="text-small text-muted font-weight-semi-bold">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true },
    text: { type: String, required: true }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.block-placeholder {
  border: 2px dashed $color-ui--grey-40;
  height: 100%;
}
</style>
